import OrderItemModel, { OrderItemModelV2 } from "./order_item_model";
import { CustomerDetailModel } from "./customer_detail_model";

import { DiscountDataModel } from "./order_discount_model";
import { TransactionDataModel } from "../trannsaction_model";

import {
  PO_STATUS,
  PaymentStatus,
  AddressType,
  OrderType,
  OrderStatus,
} from "../../../utils/enums";
import { ItemMovementModel } from "../../../erp/inventory/models/inventory_voucher";
import { BaseModel } from "../base";
export interface OrderModel {
  [key: string]: any;
}

export interface PackagingWarehouse {
  id: string;
  name: string;
  address: string;
}

export interface ScannedDeviceModel {
  device_id: string;
  device_group: string;
  manufacturer_id: string;
  pcb_number: string;
  serial_number: string;
  remarks: string;
  variant_id: string;
  inventory_found: boolean;
}

export interface OrderDeviceBox extends BaseModel {
  box_id: string;
  scanned_devices: ScannedDeviceModel[];
  warehouse: PackagingWarehouse;
}

export const defaultOrderDeviceBox: OrderDeviceBox = {
  _id: "", // from BaseModel — adjust based on your BaseModel definition
  id: "",
  box_id: "",
  scanned_devices: [],
  warehouse: {
    id: "",
    name: "",
    address: "",
  },
};

export interface OrderModel {
  id: number;
  order_id: string;
  user_id: number;
  type: string;
  customer: CustomerDetailModel;
  delivery_profile: CustomerDetailModel;
  billing_profile: CustomerDetailModel;
  billing_profile_id: number;
  delivery_profile_id: number;
  customer_id: number;
  products: OrderItemModelV2[];
  services: OrderItemModelV2[];
  raw_materials: OrderItemModelV2[];
  discountData: DiscountDataModel[];
  excessData: OrderItemModelV2[];
  transactionData: TransactionDataModel[];

  subtotal: number;
  discount: number;
  excess: number;
  paid: number;
  total: number;
  created_by?: number;
  updated_by?: number;
  created_by_name?: string;
  updated_by_name?: string;
  created_at?: string;
  updated_at?: string;
  payment_status: string;
  status: string;
  po_status: string;
  completed_at?: Date;
  order_date: Date;
  comment?: string[];
  sales_person_id?: string;
  sales_person_name?: string;
  source?: string;
  demo?: boolean;
  expected_pay_date?: Date;
  next_delivery_date?: Date;
  remark?: string;
  category?: string;
  rm_uid?: string;
  rm_name?: string;
  rm2_uid?: string;
  rm2_name?: string;
  site_survey?: string;
  site_survey_remark?: string;
  wiring_status?: string;
  wiring_remark?: string;

  installation_remark?: string;
  load_sanction?: number;
  subsidy_status?: string;
  qc_status?: string;
  monthly_recurring_fee?: string;
  monthly_recurring_payment_term?: string;
  collection_start_date?: string;
  per_month?: number;
  per_transaction?: number;
  per_unit?: number;
  payment_voc?: string;
  registration_doc_issued?: string;
  no_device_registered?: number;
  registration_remark?: string;
  meter_type?: string;
  hold_remark?: string;
  registration_number?: string;
  subsidy_claimed_qty?: number;
  discom?: string;
  segment?: string;
  sale_type: string;
  survey_date?: Date;
  sld_and_boq_date?: Date;
  sld_and_boq_approval_date?: Date;
  installation_date?: Date;
  commission_date?: Date;
  dealer_code?: string;
  currency?: {
    formal_name: string;
    symbol: string;
    short_name: string;
  };
  currency_to_inr: number;
}
export interface OrderByItemModel {
  id: number;
  order_id: string;
  user_id: number;
  type: string;
  customer: CustomerDetailModel;
  customer_id: string;
  items?: OrderItemModel;
  products?: OrderItemModelV2[];
  services?: OrderItemModelV2[];
  raw_materials?: OrderItemModelV2[];
  excessData?: OrderItemModelV2[] | ItemMovementModel[];
  discountData: DiscountDataModel[];
  transactionData: TransactionDataModel[];

  subtotal: number;
  discount: number;
  excess: number;
  paid: number;
  total: number;
  created_by?: number;
  updated_by?: number;
  created_by_name?: string;
  updated_by_name?: string;
  created_at?: string;
  updated_at?: string;
  payment_status: string;
  status: string;
  po_status: string;
  completed_at?: Date;
  order_date: string;
  comment?: string[];
  sales_person_id?: number;
  sales_person_name?: string;
  source?: string;
  demo?: boolean;
  expected_pay_date?: string;
  next_delivery_date?: string;
  remark?: string;
  category?: string;
  rm_uid?: number;
  rm_name?: string;
  site_survey?: string;
  site_survey_remark?: string;
  wiring_status?: string;
  wiring_remark?: string;

  installation_remark?: string;
  load_sanction?: number;
  subsidy_status?: string;
  qc_status?: string;
  monthly_recurring_fee?: string;
  monthly_recurring_payment_term?: string;
  collection_start_date?: string;
  per_month?: number;
  per_transaction?: number;
  per_unit?: number;
  payment_voc?: string;
  registration_doc_issued?: string;
  no_device_registered?: number;
  registration_remark?: string;
  meter_type?: string;
  hold_remark?: string;
  registration_number?: string;
  subsidy_claimed_qty?: string;
  discom?: string;
  segment?: string;
  currency?: {
    formal_name: string;
    symbol: string;
    short_name: string;
  };
  currency_to_inr: number;
}

export const defaultOrderVal: OrderModel = {
  id: 0,
  po_status: PO_STATUS.pending,
  customer_id: 0,
  order_date: new Date(),
  order_id: "",
  payment_status: PaymentStatus.PENDING_PAYMENT,
  user_id: 0,
  customer: {
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    alt_mobile: "",
    address: {
      line1: "",
      state: "",
      city: "",
      country: "India",
      pincode: 0,
      type: AddressType.HOME,
    },
    first_name: "",
    last_name: "",
    email_verified: false,
    mobile_verified: false,
    active: true,
    isEmp: false,
  },
  monthly_recurring_fee: "No",
  type: OrderType.B2C,
  total: 0,
  paid: 0,
  status: OrderStatus.CONFIRMED,
  subtotal: 0,
  discount: 0,
  excess: 0,

  transactionData: [],
  excessData: [],
  discountData: [],
  delivery_profile_id: 0,
  delivery_profile: {
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    alt_mobile: "",
    address: {
      line1: "",
      state: "",
      city: "",
      country: "India",
      pincode: 0,
      type: AddressType.HOME,
    },
    first_name: "",
    last_name: "",
    email_verified: false,
    mobile_verified: false,
    active: false,
  },
  products: [],
  services: [],
  raw_materials: [],
  sale_type: "",
  billing_profile: {
    firstName: "",
    mobile: "",
    alt_mobile: "",
    email: "",
    address: {
      line1: "",
      city: "",
      state: "",
      country: "",
      pincode: 0,
    },
    first_name: "",
    last_name: "",
    email_verified: false,
    mobile_verified: false,
    active: false,
  },
  billing_profile_id: 0,
  currency: {
    formal_name: "Indian Rupee",
    symbol: "₹",
    short_name: "INR",
  },
  currency_to_inr: 1,
};
